import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AddSupplierModal = ({ show, onClose, onSave, isEditMode, supplierToEdit, saving = false }) => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    fio: '',
    currency: 'USD',
  });
  const navigate = useNavigate();

  useEffect(() => {
    if (isEditMode && supplierToEdit) {
      setFormData({
        name: supplierToEdit.name || '',
        phone: supplierToEdit.phone || '',
        fio: supplierToEdit.fio || '',
        currency: supplierToEdit.currency || 'UZS',
        id: supplierToEdit.id, // keep id for edit
      });
    } else {
      setFormData({ name: '', phone: '', fio: '', currency: 'USD' });
    }
  }, [isEditMode, supplierToEdit, show]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    const supplier = isEditMode ? { ...formData, id: supplierToEdit.id } : { ...formData };
    onSave(supplier);
  };

  if (!show) return null;

  return (
    <div className="modal show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{isEditMode ? "Tahrirlash" : "Qo‘shish"}</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <form>
              <div className="mb-3">
                <label className="form-label">Nom*</label>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Telefon raqam*</label>
                <input
                  type="text"
                  className="form-control"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">FIO*</label>
                <input
                  type="text"
                  className="form-control"
                  name="fio"
                  value={formData.fio}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Valyuta*</label>
                <select
                  className="form-select"
                  name="currency"
                  value={formData.currency}
                  onChange={handleChange}
                  required
                  disabled={isEditMode}
                >
                  <option value="UZS">UZS</option>
                  <option value="USD">USD</option>
                </select>
              </div>
            </form>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose} disabled={saving}>
              Bekor qilish
            </button>
            <button type="button" className="btn btn-success" onClick={handleSave} disabled={saving}>
              {saving ? "Saqlanmoqda..." : (isEditMode ? "Saqlash" : "Qo‘shish")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddSupplierModal;